import { useState, useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Set mobile view threshold
  const location = useLocation();

  // Track window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Function to toggle the mobile navbar
  const openBar = () => {
    const bar = document.querySelector(".bar");
    bar.classList.toggle("opened");
  };

  // Toggle dropdown visibility
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="row">
          {/* Logo */}
          <h1 className="logo">
            <RouterLink to="/">
              <img src="/seioniclogo.png" alt="Seionic Technologies Logo" />
            </RouterLink>
          </h1>
          <ul className="bar">
            <li>
              <RouterLink onClick={openBar} to="/">
                Home
              </RouterLink>
            </li>
            <li>
              <RouterLink onClick={openBar} to="/About">
                About
              </RouterLink>
            </li>
            <li>
              {/* Conditionally render dropdown or direct links */}
              {isMobile ? (
                <>
                  <RouterLink onClick={openBar} to="/Embedded-Systems">
                    Embedded Systems
                  </RouterLink>{" "}
                  <br /> <br /> <br />
                  <RouterLink onClick={openBar} to="/Intelligent-Transport">
                    Intelligent Transport Systems
                  </RouterLink>{" "}
                  <br /> <br /> <br />
                  <RouterLink onClick={openBar} to="/Software-Development">
                    Software Development
                  </RouterLink>
                  <br /> <br /> <br />
                  <RouterLink onClick={openBar} to="/Display-Panel">
                    Display Panel
                  </RouterLink>
                </>
              ) : (
                <div className="dropdown">
                  <div onClick={toggleDropdown} className="dropdown-link">
                    Verticals
                    <img
                      src="/img/arrow.png"
                      alt="Dropdown Arrow"
                      className="dropdown-arrow"
                    />
                  </div>
                  {dropdownOpen && (
                    <ul className="dropdown-menu">
                      <li>
                        <RouterLink
                          to="/Embedded-Systems"
                          onClick={() => setDropdownOpen(false)}
                        >
                          Embedded Systems
                        </RouterLink>
                      </li>
                      <li>
                        <RouterLink
                          to="/Intelligent-Transport"
                          onClick={() => setDropdownOpen(false)}
                        >
                          Intelligent Transport Systems
                        </RouterLink>
                      </li>
                      <li>
                        <RouterLink
                          to="/Software-Development"
                          onClick={() => setDropdownOpen(false)}
                        >
                          Software Development
                        </RouterLink>
                      </li>

                      <li>
                        <RouterLink
                          to="/Display-Panel"
                          onClick={() => setDropdownOpen(false)}
                        >
                          Interactive Display Panel
                        </RouterLink>
                      </li>
                    </ul>
                  )}
                </div>
              )}
            </li>
            <li>
              <RouterLink onClick={openBar} to="/Careers">
                Careers
              </RouterLink>
            </li>
            <li>
              <RouterLink onClick={openBar} to="/Clients">
                Clients
              </RouterLink>
            </li>

            <li>
              <RouterLink onClick={openBar} to="/Manufacturing-Partner">
                Partners
              </RouterLink>
            </li>
            <li>
              <RouterLink onClick={openBar} to="/Contact">
                Contact
              </RouterLink>
            </li>
          </ul>
          {/* Burger button for mobile */}
          <div className="button" onClick={openBar}>
            <div className="burger"></div>
            <div className="burger"></div>
            <div className="burger"></div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
